export default __webpack_public_path__ + "static/media/img2.568df06c.jpg";